<template>
  <section class="app-main">
    <el-tabs type="border-card" v-model="tab">
      <el-tab-pane name="info" label="修改商品基本信息">
        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品语言： </el-col>
            <el-col :span="22">
              <el-radio
                v-model="goods.language"
                @change="getDetail($route.params.id)"
                label="zh"
                border
                style="width: 130px"
                >中文录入</el-radio
              >
              <el-radio
                v-model="goods.language"
                @change="getDetail($route.params.id)"
                label="en"
                border
                style="width: 130px"
                >英文录入</el-radio
              >
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品类型： </el-col>
            <el-col :span="22">
              <el-radio
                v-model="goods.goods_type"
                label="1"
                border
                style="width: 130px"
                >普通商品</el-radio
              >
              <el-radio
                v-model="goods.goods_type"
                label="2"
                border
                style="width: 130px"
                >食品类型</el-radio
              >
              <el-radio
                v-model="goods.goods_type"
                label="3"
                border
                style="width: 130px"
                >服务类型</el-radio
              >
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 税费类型： </el-col>
            <el-col :span="22">
              <el-radio
                v-model="goods.tax_type"
                label="1"
                border
                style="width: 130px"
                >收税</el-radio
              >
              <el-radio
                v-model="goods.tax_type"
                label="2"
                border
                style="width: 130px"
                >免税</el-radio
              >
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品名称： </el-col>
            <el-col :span="22">
              <el-input
                v-model="goods.name"
                placeholder="请输入商品名称"
                style="width: 400px"
              ></el-input>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 关联词语： </el-col>
            <el-col :span="22">
              <el-input
                v-model="goods.description"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="请输入商品关联词语(逗号隔开)"
                style="width: 400px"
              ></el-input>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品分类： </el-col>
            <el-col :span="22">
              <el-select
                v-model="goods.type_id"
                filterable
                multiple
                placeholder="请选择"
                style="width: 400px"
              >
                <el-option
                  v-for="it in classifyOptions"
                  :key="it.id"
                  :label="goods.language == 'zh' ? it.title : it.title_en"
                  :value="it.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品主图： </el-col>
            <el-col :span="22">
              <m-upload
                :img.sync="image"
                :width="120"
                :height="120"
                file-name="goodsImg"
                placement="right"
              />
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 图片要求： </el-col>
            <el-col :span="22" class="input-left tips">
              仅接受JPG、JPEG、PNG格式，200*200
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 商品视频： </el-col>
            <el-col :span="22">
              <m-video
                :video.sync="video"
                :width="120"
                :height="120"
                file-name="goodsVideo"
              ></m-video>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 视频要求： </el-col>
            <el-col :span="22" class="input-left tips">
              （可不上传）仅接受MP4格式，375*375
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 轮播图： </el-col>
            <el-col :span="22">
              <m-uploads
                :imgs.sync="banner"
                :width="120"
                :height="120"
                file-name="goodsBanner"
              ></m-uploads>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 图片要求： </el-col>
            <el-col :span="22" class="input-left tips">
              仅接受JPG、JPEG、PNG格式，375*375
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 详情图： </el-col>
            <el-col :span="22">
              <m-uploads
                :imgs.sync="details"
                :width="120"
                :height="120"
                file-name="goodsDetails"
              ></m-uploads>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 图片要求： </el-col>
            <el-col :span="22" class="input-left tips">
              仅接受JPG、JPEG、PNG格式，375*375
            </el-col>
          </el-row>
        </el-card>

        <el-card class="m-bottom-4">
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 售后服务： </el-col>
            <el-col :span="22">
              <el-radio
                v-model="goods.after_sale"
                :label="1"
                border
                style="width: 130px"
                >七天无理由</el-radio
              >
              <el-radio
                v-model="goods.after_sale"
                :label="2"
                border
                style="width: 180px"
                >非质量问题不退不换</el-radio
              >
              <el-radio
                v-model="goods.after_sale"
                :label="3"
                border
                style="width: 180px"
                >商品售出不退不换</el-radio
              >
            </el-col>
          </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 售后说明： </el-col>
            <el-col :span="22" class="input-left tips">
              <el-input
                v-model="goods.after_sale_content"
                placeholder="请输入售后说明"
                style="width: 570px"
              ></el-input>
            </el-col>
          </el-row>
        </el-card>

        <el-card>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 提交修改： </el-col>
            <el-col :span="22">
              <el-button
                @click="handleSubmit()"
                type="success"
                plain
                style="width: 150px"
                >确认修改</el-button
              >
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>

      <el-tab-pane v-if="fasle" name="sku" label="修改商品SKU">
        <el-card class="m-bottom-4" style="overflow-y: auto">
          <el-row
            class="m-bottom-4"
            style="
              border: 1px solid #dddfe1;
              padding: 10px;
              min-height: 40px;
              user-select: none;
            "
          >
            <el-tag
              type="info"
              closable
              v-for="(it, index) in skuItems"
              :key="index"
              style="margin: 0 15px 12px 0"
              @close="skuReduce(index, it)"
              >{{ it.attr_symbol_string }}</el-tag
            >
            <el-tag style="cursor: pointer" effect="plain" @click="skuAdd()"
              >添加 SKU</el-tag
            >
          </el-row>
          <div class="sku-tips m-bottom-4">
            Tips：添加SKU，只能在当前商品所具有的规格下添加属性，点击添加SKU会默认复制第一条SKU的信息，条形码默认为0不可修改，在添加成功后会自动生成
          </div>
          <el-row class="m-bottom-4" v-show="skuItems.length != 0">
            <div class="sku-items-head">
              <div
                class="m-width-140"
                v-for="(item, index) in skuHead"
                :key="index"
              >
                <span>{{ item.title + " | " + item.title_en }}</span>
              </div>
              <div class="m-width-100"><span>销售价(C$)</span></div>
              <div class="m-width-100"><span>预售价(C$)</span></div>
              <div class="m-width-100"><span>代理价(C$)</span></div>
              <div class="m-width-120"><span>重量(单位kg)</span></div>
              <div class="m-width-100"><span>长(单位cm)</span></div>
              <div class="m-width-100"><span>宽(单位cm)</span></div>
              <div class="m-width-100"><span>高(单位cm)</span></div>
              <div class="m-width-160"><span>条形码</span></div>
              <div class="m-width-100"><span>变量图片</span></div>
            </div>
            <div
              class="sku-items-body"
              v-for="(it, index) in skuItems"
              :key="index"
            >
              <div
                class="m-width-140"
                v-for="(item, ind) in it.attr"
                :key="ind"
              >
                <el-input
                  v-model="item.attr_title"
                  @change="changeAttr(1, it)"
                  size="small"
                  style="margin-bottom: 5px"
                ></el-input>
              </div>
              <div
                class="m-width-140"
                v-for="(item, ind) in it.attr"
                :key="ind"
              >
                <el-input
                  v-model="item.attr_title_en"
                  @change="changeAttr(2, it)"
                  size="small"
                ></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.price" size="small"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.pre_sale_price" size="small"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.proxy_price" size="small"></el-input>
              </div>
              <div class="m-width-120">
                <el-input v-model="it.goods_weight" size="small"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.goods_length" size="small"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.goods_width" size="small"></el-input>
              </div>
              <div class="m-width-100">
                <el-input v-model="it.goods_height" size="small"></el-input>
              </div>
              <div class="m-width-160">
                <el-input v-model="it.barcode" size="small"></el-input>
              </div>
              <div class="m-width-100" style="text-align: center">
                <m-upload
                  :img.sync="it.pic_image"
                  :width="70"
                  :height="70"
                  file-name="goodSku"
                  placement="right"
                />
              </div>
            </div>
          </el-row>
        </el-card>
        <el-card>
          <el-row class="m-bottom-4">
            <el-col :span="2" class="input-left"> 提交修改： </el-col>
            <el-col :span="22">
              <el-button @click="handleSku()" type="success" plain
                >确认修改</el-button
              >
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>
<script>
import {
  goods_get,
  goods_put,
  //   goods_sku,
  sku_update,
  sku_del,
} from "@/api/goods.js";
import { classify_list } from "@/api/goods.js";
import MUpload from "@/components/m-upload.vue";
import MVideo from "@/components/m-video.vue";
import MUploads from "@/components/m-uploads.vue";
export default {
  name: "presellGoodsEdit",
  components: { MUpload, MUploads, MVideo },
  data() {
    return {
      tab: "info",
      image: { url: "", pic_id: "" }, // 主图
      banner: [],
      details: [],
      video: { video_pic: "", video_id: "" },
      goods: {
        name: "",
        language: "zh",
        goods_type: "1",
        tax_type: "1",
        type_id: [],
        description: "",

        after_sale: 1,
        after_sale_content: "",
      },
      classifyOptions: [],
      skuItems: [],
      skuAttr: [],
      skuHead: [],
    };
  },
  methods: {
    // 获取商品详情
    getDetail(id) {
      let params = {
        language: this.goods.language,
      };
      goods_get(id, params).then((res) => {
        if (res) {
          this.goods.goods_type = res.data.goods_type + "";
          this.goods.tax_type = res.data.tax_type + "";
          this.goods.name = res.data.name;
          this.goods.description = res.data.description;
          this.goods.name = res.data.name;
          this.goods.type_id = [];
          res.data.type_id.forEach((e) => {
            this.goods.type_id.push(e.type_id);
          });
          if (res.data.video_id != 0) {
            this.video = res.data.video_url;
          } else {
            this.video = { video_pic: "", video_id: "" };
          }
          this.image.url = res.data.pic_image.url;
          this.image.pic_id = res.data.pic_image.pic_id;
          this.banner = res.data.round_pic_url;
          this.details = res.data.goods_details;
          this.goods.after_sale = res.data.after_sale;
          this.goods.after_sale_content = res.data.after_sale_content;
        }
      });
    },
    // 获取分类数据
    getClassify() {
      let params = {
        level: 2,
      };
      classify_list(params).then((res) => {
        if (res) {
          this.classifyOptions = res.data;
        }
      });
    },
    // 删除SkU
    skuReduce(index, it) {
      if (this.skuItems.length >= 1) {
        this.$message.error("商品至少要保留一个SKU");
        return false;
      }
      this.$confirm(
        `此操作将删除 ${it.attr_symbol_string}, 是否继续?`,
        "提示",
        { type: "warning" }
      )
        .then(() => {
          let parmas = { id: it.id };
          sku_del(parmas).then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: res.msg,
                duration: 1500,
              });
              this.skuItems.splice(index, 1);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 添加SKU
    skuAdd() {
      let obj = JSON.parse(JSON.stringify(this.skuItems[0]));
      obj.id = 0;
      obj.barcode = 0;
      delete obj.attr_symbol_path;
      obj.pic_image.url = "";
      obj.pic_image.pic_id = "";
      obj.attr.forEach((e) => {
        e.symbol = 0;
      });
      this.skuItems.push(obj);
    },

    // 新的sku 发生改变
    changeAttr(index, it) {
      if (index == 1) {
        let arr = [];
        it.attr.forEach((e) => {
          arr.push(e.attr_title);
        });
        it.attr_symbol_string = arr.join(",");
      } else {
        let arr = [];
        it.attr.forEach((e) => {
          arr.push(e.attr_title_en);
        });
        it.attr_symbol_string_en = arr.join(",");
      }
    },

    // 基础信息 确定修改
    handleSubmit() {
      let banner = [];
      this.banner.forEach((e) => {
        banner.push(e.pic_id);
      });
      let details = [];
      this.details.forEach((e) => {
        //   console.log(e.pic_id);
        details.push(e.pic_id);
      });

      let params = {
        name: this.goods.name,
        language: this.goods.language,
        goods_details: details.join(","),
        goods_type: this.goods.goods_type,
        tax_type: this.goods.tax_type,
        type_id: this.goods.type_id.join(","),
        description: this.goods.description,
        image: this.image.pic_id,
        round_pic: banner.join(","),
        merchant_id: 1,
        after_sale: this.goods.after_sale,
        after_sale_content: this.goods.after_sale_content,
      };

      if (this.video.video_id && this.video.video_id != "") {
        params.video_id = this.video.video_id;
      } else {
        params.video_id = 0;
      }

      // if (this.goods.name == "") {
      //   this.$message.error("请先完善商品名称");
      //   return false;
      // }
      if (this.goods.type_id.length == 0) {
        this.$message.error("至少选择一个商品分类");
        return false;
      }
      if (this.image.pic_id == "") {
        this.$message.error("请先完善商品主图");
        return false;
      }
      if (banner.length == 0) {
        this.$message.error("至少上传一轮播图");
        return false;
      }
      // if (details.length == 0) {
      //   this.$message.error("至少上传一张详情图");
      //   return false;
      // }

      goods_put(this.$route.params.id, params).then((res) => {
        if (res) {
          this.$message({ type: "success", message: res.msg, duration: 1500 });
          //   this.tab = "sku";
          this.$router.go(-1);
        }
      });
    },

    handleSku() {
      let skuBol = false;
      this.skuItems.forEach((params) => {
        params.sku_pic = params.pic_image.pic_id;
        for (let key in params) {
          if (
            params[key] === "" ||
            params[key] === undefined ||
            params[key] === null ||
            params[key].length == 0 ||
            params[key].pic_id == ""
          ) {
            skuBol = true; // 终止程序
          }
          if (params.id == 0) {
            params.cost_price = params.price
          }
        }
      });
      if (skuBol) {
        this.$message.error("请务必完善SKU每条信息");
        return false;
      }

      console.log(this.skuItems);
      sku_update(this.skuItems).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.$router.go(-1);
            },
          });
        }
      });
    },
  },

  created() {
    if (this.$route.query.param) {
      this.goods.language = this.$route.query.param
    }
    this.getClassify();
    this.getDetail(this.$route.params.id);
  },
  activated() {
    if (this.$route.query.param) {
      this.goods.language = this.$route.query.param
    }
    this.getDetail(this.$route.params.id);
  },
};
</script>
<style lang="less" scoped>
.sizing {
  box-sizing: border-box;
}
section {
  .input-left {
    height: 40px;
    line-height: 40px;
    min-width: 80px;
  }
  .tips {
    color: #909399;
    font-size: 14px;
  }
  .sku-value {
    height: 40px;
    line-height: 40px;
    margin: 20px 15px 0 0;
  }
  .sku-input {
    width: 150px;
    margin-right: 20px;
  }
  .m-width-100 {
    width: 100px;
  }
  .m-width-120 {
    width: 120px;
  }
  .m-width-140 {
    width: 140px;
  }
  .m-width-160 {
    width: 160px;
  }
  .sku-items-head {
    min-width: 1305px;
    display: flex;
    background: #f5f7fa;
    border: 1px solid #e8e8e8;
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      padding: 0 8px;
      font-size: 15px;
      color: #8c939d;
      > span {
        display: inline-block;
        width: 100%;
        height: 36px;
        background: #fff;
        text-align: center;
        line-height: 36px;
        border-radius: 3px;
      }
    }
  }
  .sku-items-body {
    min-width: 1305px;
    display: flex;
    border: 1px solid #e8e8e8;
    border-top: none;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 80px;
      padding: 0 8px;
      font-size: 15px;
      color: #8c939d;
    }
    .avatar-uploader-icon {
      width: 60px;
      height: 60px;
      line-height: 60px !important;
      border: 1px solid #e0e0e0;
    }
  }
  .sku-tips {
    line-height: 30px;
    margin-top: 5px;
    color: red;
  }
  /deep/ .el-input--small .el-input__inner {
    text-align: center;
  }
}
</style>

